import { useLocation } from 'react-router-dom';
import { getAppName } from '@rsos/utils/metaTags';

const useAppNameToPage = () => {
  const location = useLocation();
  const appName = getAppName();

  const appsWithMultiplePaths = ['access_management', 'integration_management'];

  // 2 underscores (__) represents looking at the pathname
  // 1 underscore (_) represents continued singular name
  const READABLE_APP_NAMES = {
    access_management__roles: 'admin roles and access',
    access_management__security: 'security',
    access_management__users: 'admin users',
    alerts_routing: 'alerts routing',
    central_station: 'data',
    datasource_management: 'data source',
    emergency_data: 'data',
    integration_management__inbound: 'inbound data',
    integration_management__outbound: 'outbound data',
    peer_agencies: 'peer agencies',
    psap_management: 'admin agency info',
    settings_management: 'sound control',
  };

  if (READABLE_APP_NAMES[appName]) {
    return READABLE_APP_NAMES[appName];
  } else if (appsWithMultiplePaths.includes(appName)) {
    const pathname = location.pathname;
    const page = pathname
      .substring(pathname.lastIndexOf('/') + 1)
      .toLowerCase();
    return READABLE_APP_NAMES[`${appName}__${page}`];
  }

  return undefined;
};

export default useAppNameToPage;
